import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { PersistGate } from 'redux-persist/integration/react';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import reducer from './rootReducer';
import { BrowserRouter } from 'react-router-dom';
import TopNav from './NavBar/TopNav';
import AuthenticationComponent from './AuthenticationComponent';
import registerServiceWorker from './registerServiceWorker';
// import * as Sentry from "@sentry/react";
// import { Integrations } from "@sentry/tracing";
// import LogRocket from 'logrocket'
import RouteContainer from './routes/RouteContainer';
import 'react-quill/dist/quill.snow.css'; // ES6
import 'react-bootstrap-typeahead/css/Typeahead.css';
import './static/css/animate.min.css';
import './global.css';
// import { composeWithDevTools } from 'redux-devtools-extension';

// Sentry.init({
//   dsn: process.env.REACT_APP_SENTRY_DSN,
//   integrations: [new Integrations.BrowserTracing()],
//
//     // We recommend adjusting this value in production, or using tracesSampler
//     // for finer control
//     tracesSampleRate: 1.0,
// })
//
// LogRocket.init(process.env.REACT_APP_LOG_ROCKET_URL, {
//   mergeIframes: true,
//   childDomains: ['https://v5.organimi.com/p/o/5e3b43fe96df080015354ea0/c/5e3b441b2e26f9001580f625/chart'],
//   network: {
//     requestSanitizer: request => {
//       // ignore login requests to obscure password
//       const lowerUrl = request.url.toLowerCase()
//       if (lowerUrl.includes('login') || lowerUrl.includes('change-password') || lowerUrl.includes('recover-password')) {
//         // ignore the request response pair
//         return null
//       }
//       // otherwise log the request normally
//       return request
//     },
//   }
// })
//
// LogRocket.getSessionURL(sessionURL => {
//   Sentry.configureScope(scope => {
//     scope.setExtra("sessionURL", sessionURL)
//   })
// })

const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel2,
}

// const sentryReduxEnhancer = Sentry.createReduxEnhancer({
//   // Optionally pass options
// });

const persistedReducer = persistReducer(persistConfig, reducer)
/// REMOVE composeWithDevTools FUNCTION WHEN RUNNING A BUILD!!!
// const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(thunk), sentryReduxEnhancer))
const store = createStore(persistedReducer, compose(applyMiddleware(thunk)))

const persistor = persistStore(store)
window.persistor = persistor

const pkg = require('../package.json')
let version = `v${pkg.version}`

if (["DEV", "STAGING"].includes(process.env.REACT_APP_MODE)) {
  version = `${version} ${process.env.REACT_APP_MODE}`
}
console.log(version)

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={<p>Loading</p>} persistor={persistor}>
      <BrowserRouter>
        <div>
          <TopNav />
          <AuthenticationComponent />
          <RouteContainer />
        </div>
      </BrowserRouter>
    </PersistGate>
  </Provider>
  , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js